import React from "react";

const ToggleSwitch = ({ checked, onChange, label, disabled = false, size = "default" }) => {
  const w = size === "small" ? 32 : 38;
  const h = size === "small" ? 18 : 22;
  const thumb = size === "small" ? 14 : 16;
  const offset = size === "small" ? 2 : 3;

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        userSelect: "none",
        opacity: disabled ? 0.45 : 1,
        verticalAlign: "middle",
      }}
      onClick={disabled ? undefined : () => onChange(!checked)}
    >
      <div
        style={{
          width: w,
          height: h,
          borderRadius: h / 2,
          flexShrink: 0,
          position: "relative",
          background: checked ? "#1976d2" : "rgba(130,130,130,0.35)",
          transition: "background 0.2s",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: offset,
            width: thumb,
            height: thumb,
            borderRadius: "50%",
            background: "#fff",
            boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
            left: checked ? w - thumb - offset : offset,
            transition: "left 0.18s",
          }}
        />
      </div>
      {label && (
        <span style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.3 }}>
          {label}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;
